import React, { ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  children: ReactNode
}

const Row = styled.tr`
border: 1px solid #E9EEF5!important;
`

export const TableRow: React.FC<Props> = ({ children }) => (
  <Row>
    {children}
  </Row>
)

